module.exports = __webpack_public_path__ + "static/media/loc3_img15.638cda26.jpg";